import { render } from "./V2About.vue?vue&type=template&id=b1ae4302&scoped=true"
import script from "./V2About.vue?vue&type=script&lang=js"
export * from "./V2About.vue?vue&type=script&lang=js"

import "./V2About.vue?vue&type=style&index=0&id=b1ae4302&scoped=true&lang=css"

import exportComponent from "/Users/brianschroeter/Documents/Codex/2026-10-09/task/giving-dashboard-donor-fix/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1ae4302"]])

export default __exports__